<template>
<v-autocomplete
  v-model="select"
  :items="items"
  :loading="loading"
  :search-input.sync="search"
  hide-no-data
  no-filter
  return-object

  :menu-props="{ offsetY: true, fixed: true }"
  :label="$t('Standort')"
  :placeholder="placeholder"

  no-data-text="Keine passenden Orte gefunden"
  attach
  @change="change"
  filled

  clearable
></v-autocomplete>
</template>

<script>
import { GeocoderFactory } from "./Geocoder";

export default {
  name: "GeocoderAutocomplete",

  props: [
    "value",
    "placeholder",
    "hide-details"
  ],

  data() {
    return {
      loading: false,
      search: null,
      select: null,
      items: []
    };
  },

  created() {
    this.timer = null;
    this.requestSeq = 0;
    this.destroyed = false;
    this.geocoder = null;

    GeocoderFactory().then(geocoder => {
      if (!this.destroyed) {
        this.geocoder = geocoder;
      }
    });
  },

  beforeDestroy() {
    this.destroyed = true;
    this.stopPending();
  },

  watch: {
    search(val) {
      if (!val || !String(val).trim()) {
        this.stopPending();
        this.items = this.select ? [this.select] : [];
        return;
      }

      if (val === this.select || (this.select && val === this.select.text)) {
        return;
      }

      this.querySelections(val);
    },

    value(val) {
      if (val) {
        this.select = val;
      }
    }
  },

  methods: {
    // beendet Timer und laufende Anfrage und invalidiert verspaetete Antworten
    stopPending() {
      this.requestSeq++;

      if (this.timer != null) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      if (this.geocoder) {
        this.geocoder.cancelAutocomplete();
      }

      this.loading = false;
    },

    querySelections(value) {
      this.stopPending();

      if (!this.geocoder) {
        return;
      }

      const seq = this.requestSeq;
      this.loading = true;

      this.timer = setTimeout(() => {
        this.timer = null;

        if (seq !== this.requestSeq || this.destroyed) {
          return;
        }

        this.geocoder.autocomplete(value).then(items => {
          if (seq === this.requestSeq) {
            this.items = items.slice();
          }
        }).catch(err => {
          if (seq === this.requestSeq && !this.geocoder.isCancelled(err)) {
            this.items = [];
          }
        }).finally(() => {
          if (seq === this.requestSeq) {
            this.loading = false;
          }
        });
      }, 150);
    },

    change(o) {
      this.stopPending();
      this.$emit("change", o);
    }
  }
};
</script>
